class FeatureToggles {
  private toggles: Record<string, boolean>;

  constructor(initialToggles: Record<string, boolean> = {}) {
    this.toggles = initialToggles;
  }

  isEnabled(featureName: string): boolean {
    return !!this.toggles[featureName];
  }
}

export const featureToggles = new FeatureToggles({
  enableClientsPlans: true,
  enablePurchaseSection: true,
});
